import {Component, computed, inject, input, OnInit, signal} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatCard} from '@angular/material/card'
import {MatProgressBar} from '@angular/material/progress-bar'
import {SpbAccessibleLinkDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {WINDOW} from '../../application/app'
import {PleaseWaitComponent} from '../../components/please-wait/please-wait.component'
import {ConfigService} from '../../services/config.service'
import {KycService, PutKycResponse} from '../../services/kyc.service'
import {ApplicantComponent} from './01-applicant/applicant.component'
import {CitizenshipComponent} from './02-citizenship/citizenship.component'
import {TaxResidencyComponent} from './03-tax-residency/tax-residency.component'
import {EmploymentComponent} from './04-employment/employment.component'
import {PepComponent} from './05-pep/pep.component'
import {ApproveComponent} from './06-approve/approve.component'
import {ActivatedRoute, Router} from '@angular/router'

@Component({
  selector: 'spb-borgo-kyc',
  imports: [
    MatProgressBar,
    MatButton,
    PleaseWaitComponent,
    ApproveComponent,
    SpbAccessibleLinkDirective,
    MatCard,
    ApplicantComponent,
    CitizenshipComponent,
    TaxResidencyComponent,
    EmploymentComponent,
    PepComponent
  ],
  templateUrl: './borgo-kyc.component.html',
  styleUrl: './borgo-kyc.component.scss'
})
export class BorgoKycComponent implements OnInit {
  public step = input<string>('1')
  /**
   * The current step of the "train"
   */
  public currentStep = signal(1)

  /**
   * The total steps of the train, never changes
   */
  public totalSteps = 6

  public approvalData = signal<PutKycResponse>(false)

  /**
   * Error message
   */
  public errorMessage = computed(() => {
    const message = this.approvalData()
    if (typeof message === 'object' && message.errorMessage) {
      return message.errorMessage
    }
    return undefined
  })

  public readonly service = inject(KycService)

  public readonly configService = inject(ConfigService)

  protected readonly environment = environment

  private readonly window = inject(WINDOW)

  private readonly router = inject(Router)
  private readonly route = inject(ActivatedRoute)

  public ngOnInit() {
    if (this.step()) {
      this.currentStep.set(+this.step())
    }
  }

  public nextStep() {
    this.currentStep.update(s => s + 1)
    this.router.navigate(['../', this.currentStep()], {relativeTo: this.route}).then()
  }

  public previousStep() {
    this.currentStep.update(s => s - 1)
    this.router.navigate(['../', this.currentStep()], {relativeTo: this.route}).then()
  }

  public signLink(): void {
    this.window.open(environment.signLink, '_blank')
  }
}
